import { useMemo } from 'react';
import { useLocation } from 'react-router';

const useSearchParams = () => {
  const { search } = useLocation();

  const searchParams = useMemo(() => {
    const urlSearchParams = new URLSearchParams(search);

    return Object.fromEntries(urlSearchParams.entries());
  }, [search]);

  return searchParams;
};

export default useSearchParams;
